import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsService, placeBetFlipCoinGameService } from '../flipCoin.service'
import { startFlip } from '../pixi-js-scripts/bridge'
import { openSuccessToaster } from 'helpers/toaster.helpers'
import { setFlipCoinGameWagered } from './flipCoinGame.slice'

export const placeBetFlipCoin = createAsyncThunk(
  'flip-coin/place-bet-flip-coin-game',
  async ({ onSuccess, ...data }, thunkApi) => {
    try {
      const res = await placeBetFlipCoinGameService(data)
      if (res) {
        onSuccess()
        startFlip()
      }
      thunkApi.dispatch(setFlipCoinGameWagered(res?.betAmount))
      // if (res?.result === 'won') {
      //   thunkApi.dispatch(setFlipCoinGameWins())
      //   thunkApi.dispatch(setFlipCoinGameProfit(res?.winningAmount - res?.betAmount))
      // } else if (res?.result === 'lost') {
      //   thunkApi.dispatch(setFlipCoinGameLosses())
      // }
      openSuccessToaster({
        message: 'Bet Placed successfully'
      })
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getFlipCoinBets = createAsyncThunk(
  'flip-coin/myBets',
  async (data, thunkApi) => {
    try {
      const res = await getMyBetsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
